import { Box, Center, Flex, Stack } from '@mantine/core';
import { useState } from 'react';

import { BackButton } from '@/components/common';
import { AuthHeader } from '@/components/layout';
import { RegisterForm } from '@/features/auth/components/RegisterForm';
import { RegisterHero } from '@/features/auth/components/RegisterHero';

export const RegisterPage = () => {
  const [emailConflict, setEmailConflict] = useState(false);

  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader backTo="/login" />
      <Center px={{ base: 16, md: 24 }} pt={{ base: 16, md: 32 }} pb={{ base: 32, md: 64 }}>
        <Stack gap={16} w={{ base: '100%', md: 'auto' }}>
          <Box visibleFrom="sm">
            <BackButton to="/login" />
          </Box>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            gap={{ base: 24, md: 56 }}
            align="flex-start"
            w={{ base: '100%', md: 'auto' }}
          >
            {!emailConflict && <RegisterHero />}
            <RegisterForm onEmailConflictChange={setEmailConflict} />
          </Flex>
        </Stack>
      </Center>
    </Box>
  );
};
